export default __webpack_public_path__ + "static/button-action-dont-c4bdd0e98726138e572fc8f565e6f1e07ef9d619c12117bb37307ef5a00bbda9.png";